import type { UserAddressType } from '@/features/user/domain/enums/UserAddressType'
import type { LngLatEntity } from '@/shared/entities/LngLatEntity'

export class UpdateUserAddressEntity {
  location?: LngLatEntity
  type?: UserAddressType
  description?: string
}
